import React from 'react';
import PropTypes from 'prop-types';

const ImportMandates = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_244_5006)">
      <path
        d="M14.25 3H13.5V2.25C13.5 1.83579 13.1642 1.5 12.75 1.5V1.5C12.3358 1.5 12 1.83579 12 2.25V3H6V2.25C6 1.83579 5.66421 1.5 5.25 1.5V1.5C4.83579 1.5 4.5 1.83579 4.5 2.25V3H3.75C2.9175 3 2.2575 3.675 2.2575 4.5L2.25 15C2.25 15.825 2.9175 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM14.25 15H3.75V7.5H14.25V15ZM14.25 6H3.75V4.5H14.25V6Z"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="5"
        y="8.5"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <rect
        x="5"
        y="11.5"
        width="2.5"
        height="2.5"
        rx="0.5"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <path
        d="M11.564 9.07C11.564 8.99515 11.5492 8.92103 11.5206 8.85187C11.4919 8.78272 11.4499 8.71988 11.397 8.66695C11.3441 8.61402 11.2813 8.57203 11.2121 8.54339C11.1429 8.51474 11.0688 8.5 10.994 8.5C10.9191 8.5 10.845 8.51474 10.7758 8.54339C10.7067 8.57203 10.6438 8.61402 10.5909 8.66695C10.538 8.71988 10.496 8.78272 10.4674 8.85187C10.4387 8.92103 10.424 8.99515 10.424 9.07V11.395H9.29897C9.24018 11.3937 9.18238 11.4101 9.13308 11.4422C9.08378 11.4742 9.04529 11.5204 9.02262 11.5746C8.99995 11.6289 8.99415 11.6887 9.00599 11.7463C9.01782 11.8039 9.04674 11.8566 9.08897 11.8975L9.83897 12.6475L10.814 13.6225C10.8412 13.6506 10.8739 13.673 10.9099 13.6883C10.946 13.7035 10.9848 13.7114 11.024 13.7114C11.0631 13.7114 11.1019 13.7035 11.138 13.6883C11.1741 13.673 11.2067 13.6506 11.234 13.6225L12.929 11.9275C12.9712 11.8866 13.0001 11.8339 13.0119 11.7763C13.0238 11.7187 13.018 11.6589 12.9953 11.6046C12.9726 11.5504 12.9341 11.5042 12.8849 11.4722C12.8356 11.4401 12.7777 11.4237 12.719 11.425H11.594V9.07H11.564Z"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
    </g>
    <defs>
      <clipPath id="clip0_244_5006">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

ImportMandates.propTypes = {
  fill: PropTypes.string,
};

export default ImportMandates;
